import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useThoughtCompose = ({ onSave, isEditing = false, existingThought = null, thoughtId = null }) => {
    const navigate = useNavigate();
    const [thought, setThought] = useState(existingThought ? existingThought.thought : '');
    const [isSaving, setIsSaving] = useState(false);

    const buildThoughtPayload = useCallback(() => ({
        ...(existingThought && { id: existingThought.id }),
        thought,
        theme: existingThought?.theme || "",
        motif: existingThought?.motif || "",
        importance: existingThought?.importance || null,
        tags: existingThought?.tags || [],
        insight: existingThought?.insight ?? true,
        ...(existingThought && { timestamp: existingThought.timestamp })
    }), [existingThought, thought]);

    const handleSave = useCallback(async (keepOpen = false) => {
        if (!thought.trim() || isSaving) return;

        setIsSaving(true);

        try {
            await onSave(buildThoughtPayload());
            
            if (keepOpen) {
                setThought('');
                setIsSaving(false);
            } else {
                if (isEditing) {
                    navigate(`/thought/${thoughtId}`);
                } else {
                    navigate('/');
                }
            }
        } catch (error) {
            console.error('Error saving thought:', error);
            setIsSaving(false);
        }
    }, [thought, isSaving, onSave, buildThoughtPayload, isEditing, navigate, thoughtId]);

    return {
        thought,
        setThought,
        isSaving,
        handleSave
    };
}; 